import { render, staticRenderFns } from "./AddProduct.vue?vue&type=template&id=7aef14fc&scoped=true&"
import script from "./AddProduct.vue?vue&type=script&lang=ts&"
export * from "./AddProduct.vue?vue&type=script&lang=ts&"
import style0 from "./AddProduct.vue?vue&type=style&index=0&id=7aef14fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aef14fc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/project/xunjie/ams_old/ams-admin/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VSwitch } from 'vuetify/lib'
import { VTab } from 'vuetify/lib'
import { VTabItem } from 'vuetify/lib'
import { VTabs } from 'vuetify/lib'
import { VTabsSlider } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VTextarea } from 'vuetify/lib'
installComponents(component, {VBtn,VContainer,VFlex,VForm,VLayout,VSelect,VSwitch,VTab,VTabItem,VTabs,VTabsSlider,VTextField,VTextarea})
